import { useEffect, useState } from 'react';

const REVEAL_TOTAL_MS = 2000;
const REVEAL_MIN_WORD_DELAY_MS = 15;
const REVEAL_MAX_WORD_DELAY_MS = 80;

export default function StreamingText({
  text,
  onDone,
}: {
  text: string;
  onDone: () => void;
}) {
  const [visibleWordCount, setVisibleWordCount] = useState(0);

  const words = text.split(' ');
  const isDone = visibleWordCount >= words.length;

  useEffect(() => {
    const wordCount = text.split(' ').length;
    const pacedDelayMs = Math.max(
      REVEAL_TOTAL_MS / wordCount,
      REVEAL_MIN_WORD_DELAY_MS,
    );
    const delayMs = Math.min(pacedDelayMs, REVEAL_MAX_WORD_DELAY_MS);

    const interval = setInterval(() => {
      setVisibleWordCount((count) => Math.min(count + 1, wordCount));
    }, delayMs);

    return () => clearInterval(interval);
  }, [text]);

  useEffect(() => {
    if (isDone) onDone();
  }, [isDone, onDone]);

  return words.slice(0, visibleWordCount).join(' ');
}
